import { validateDate } from "./validateDate";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

export const getTableDateTime = (
  date: string | undefined | Date | null,
  dateOnly?: boolean,
  useFrench?: boolean,
) =>
  date && validateDate(date)
    ? format(
        typeof date === "string" ? new Date(date) : date,
        dateOnly ? "MMM d, yyyy" : "MMM d, yyyy h:mm aa",
        { locale: useFrench ? fr : undefined },
      )
    : "";
